import Isotope from 'isotope-layout';
import Filter from './class.Filter';

class AllergyFilter extends Filter {
  constructor(containerClass, itemClass) {
    super();

    if (
      !document.querySelector('.filter__list')
      || !document.querySelector(containerClass)
      || !document.querySelector(itemClass)
    ) return;

    this.containerClass = containerClass;
    this.itemClass = itemClass;

    this.buttons = [
      document.querySelector('.filter--desktop .filter-button'),
      document.querySelector('.filter--mobile .filter-button'),
    ];

    this.lists = [
      document.querySelector('.filter--desktop .filter__list'),
      document.querySelector('.filter--mobile .filter__list'),
    ];

    this.filterCheckboxes = document.querySelectorAll('.allergy-checkbox');
    this.isotopeInstance = null;

    this.init();
  }

  init() {
    this._initIsotope();
    this._initEventListeners();
  }

  _initIsotope() {
    this.isotopeInstance = new Isotope(this.containerClass, {
      itemSelector: this.itemClass,
      percentPosition: true,
      layoutMode: 'fitRows',
    });
  }

  _initEventListeners() {
    this.buttons.forEach((button, i) => {
      if (button) {
        button.addEventListener('click', () => {
          if (this.lists[i].classList.contains('filter__list--activee')) {
            this.close();
          } else {
            this.open();
          }
        });
      }
    });

    document.addEventListener('click', (e) => {
      if (e.target.closest('.filter')) return;

      if (this.isOpened()) {
        this.close();
      }
    });

    this.filterCheckboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        this.update('add', checkbox.name);
        this.filter();
      }

      checkbox.addEventListener('change', () => {
        const command = checkbox.checked ? 'add' : 'remove';
        const selector = checkbox.name;

        this.update(command, selector);
        this.filter();
      });
    });
  }

  open() {
    this.buttons.forEach((button) => (button ? button.classList.add('filter--black') : null));
    this.lists.forEach((list) => (list ? list.classList.add('filter__list--activee') : null));
  }

  isOpened() {
    return this.lists.some((list) => list && list.classList.contains('filter__list--activee'));
  }

  close() {
    this.buttons.forEach((button) => (button ? button.classList.remove('filter--black') : null));
    this.lists.forEach((list) => (list ? list.classList.remove('filter__list--activee') : null));
  }

  update(command, selector) {
    if (command === 'add') {
      super.currentAllergyFilter.push(selector);
    }

    if (command === 'remove') {
      super.currentAllergyFilter = super.currentAllergyFilter.filter((s) => selector !== s);
    }
  }

  filter() {
    const filterRule = super.generateFilterSelectorString();

    this.isotopeInstance.arrange({
      filter: filterRule,
    });
  }
}

export default AllergyFilter;
